export default function Input({ hideLabel, ...props }) {
  return (
    <div className="py-3 mb-1 flex-1">
      {!hideLabel ? (
        <label className="block mb-2 text-sm font-medium text-gray-900 ">
          {props.label}{" "}
          {props.required ? <sup className="text-red-500">*</sup> : null}
        </label>
      ) : null}
      <input
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
        {...props}
      />
    </div>
  );
}
